import { Trans, useTranslation } from "react-i18next";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./ScanVerificationHistoryTable.styles";
import SecureSyncTableCard from "src/components/common/SecureSyncTableCard/SecureSyncTableCard";
import SecureSyncTable from "src/components/common/SecureSyncTable/SecureSyncTable";
import RemoveRedEyeFilled from "src/components/Icons/RemoveRedEyeFilled/RemoveRedEyeFilled";
import {
    getScanVerificationResultHistoryPath,
    scanVerificationHistory,
} from "src/constants/routeConstants/operationsRouterFullPaths";
import { convertToLocaleUpperCase } from "src/utils/commonHelper";

const ScanVerificationHistoryTable = ({ resultData }) => {
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const theme = useTheme();

    const columns = [
        {
            field: "action",
            headerName: "",
            sortable: true,
            renderCell: (params) => {
                return (
                    <Box display={"flex"} gap={2} alignItems={"center"}>
                        <IconButton
                            onClick={() => navigate(getScanVerificationResultHistoryPath(params.Verify_Result_Id))}
                        >
                            <RemoveRedEyeFilled fill={theme.palette.im_mid_blue["500"]} />
                        </IconButton>
                    </Box>
                );
            },
        },
        {
            field: "List_Descr_Ltz",
            headerName: convertToLocaleUpperCase(t("tableHeader.list")),
            sortable: true,
        },
        {
            field: "First_Session_Date_Local_Ltz",
            headerName: convertToLocaleUpperCase(t("tableHeader.originalVerificationDateTime")),
            sortable: true,
        },
        {
            field: "First_Session_Personnel_Name",
            headerName: convertToLocaleUpperCase(t("tableHeader.originalVerificationUser")),
            sortable: true,
        },
        {
            field: "Unresolved_Count",
            headerName: convertToLocaleUpperCase(t("tableHeader.unresolvedVerificationIssues")),
            sortable: true,
        },
        {
            field: "Resolved_Count",
            headerName: convertToLocaleUpperCase(t("tableHeader.resolvedVerificationIssues")),
            sortable: true,
        },
    ];

    const onTableStateChange = (attributes) => {
        const locationState = location.state || {};
        navigate(scanVerificationHistory, { state: { ...locationState, ...attributes }, replace: true });
    };

    return (
        <SecureSyncTableCard>
            <Box sx={styles.recordCount}>
                {resultData.length > 0 ? (
                    <>
                        <Box sx={styles.recordStart}>
                            <Typography variant="body1">
                                {t("messages.recordsFound", { count: resultData.length })}
                            </Typography>
                        </Box>
                    </>
                ) : (
                    <Box sx={styles.recordStart} />
                )}
            </Box>
            <Box sx={styles.cardContent}>
                <SecureSyncTable
                    rows={resultData}
                    columns={columns}
                    getRowId={(row) => row.id}
                    noDataMessage={<Trans i18nKey={"scanVerificationHistory.noRecordsFound"} />}
                    initialPage={location.state?.pageNumber}
                    initialRowsPerPage={location.state?.rowsPerPage}
                    initialOrderBy={location.state?.orderBy}
                    initialOrder={location.state?.order}
                    onTableAttributesChange={onTableStateChange}
                />
            </Box>
        </SecureSyncTableCard>
    );
};

export default ScanVerificationHistoryTable;
